import { APIConfig, BaseAPIConfig, buildConfig, ConfigEnvironment, ConfigMap } from "@eres/api";

interface RestConfig {
	handTakeOverAPI: () => APIConfig;
}

const dev: RestConfig = {
	handTakeOverAPI: () => new BaseAPIConfig( "https", "devmobile.dubailand.gov.ae", "ejari.mobile" ),
};

const qa: RestConfig = {
	handTakeOverAPI: () => new BaseAPIConfig( "https", "stgapi.dubailand.gov.ae:8443", "qa.ejarimobile" ),
};

const prod: RestConfig = {
	handTakeOverAPI: () => new BaseAPIConfig( "https", "mobile.dubailand.gov.ae", "ejarimobile" ),
};

const configs: ConfigMap<RestConfig> = {
	dev: dev,
	qa: qa,
	production: prod,
};

const cfg = buildConfig<RestConfig, ConfigEnvironment>( "dev", configs );
export default cfg;
